import React, { Component } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { injectIntl } from 'react-intl';
import ScheduleDay from './ScheduleDay';
import ScheduleTracks from './ScheduleTracks';
import ScheduleTabs from './ScheduleTabs';
import ScheduleDialog from './ScheduleDialog';
import { getTextColorsFromSection } from '../lib/colors';
import Section, { SectionTitle } from '../Section';
import mapBy from '../lib/mapBy';

const getUniqueValues = array => [...new Set(array)];

class ScheduleSection extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    data: PropTypes.object,
    selectedDay: PropTypes.number,
    event: PropTypes.object.isRequired,
    site: PropTypes.object.isRequired,
    section: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
  };

  static defaultProps = {
    data: null,
    selectedDay: 0,
    styles: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      data: this.preProcessData(props.section.data, props.event),
      selectedTab: props.selectedDay,
      dialogData: {},
      dialogOpen: false,
    };
  }

  UNSAFE_componentWillReceiveProps({ section, event }) {
    if (section.data !== this.props.section.data) {
      this.setState({
        data: this.preProcessData(section.data, event),
      });
    }
  }

  itemsHaveDescription = items => {
    return Boolean(
      Array.isArray(items) && items.length && items.some(item => Boolean(item.description)),
    );
  };

  preProcessData = (data, event) => {
    const tracks = mapBy(data.tracks, 'id') || {};
    const shouldDisplayDialog = this.itemsHaveDescription(data.items);
    const { intl } = this.props;
    const items =
      data.items &&
      data.items.map(item => {
        const updatedItem = {
          ...item,
          date: intl.formatDate(item.date, { timeZone: event.address.timezone }),
          time: intl.formatTime(item.date, {
            timeZone: event.address.timezone,
            hour12: false,
          }),
          track: tracks[(item.trackIds || []).find(trackId => tracks[trackId])] || false,
        };
        updatedItem.onClick = shouldDisplayDialog ? this.onRequestDialogOpen(updatedItem) : null;
        return updatedItem;
      });
    return { ...data, items };
  };

  onTabClick = tab => this.setState({ selectedTab: tab });

  onRequestDialogClose = () => this.setState({ dialogOpen: false });

  onRequestDialogOpen = data => () => this.setState({ dialogOpen: true, dialogData: data });

  render() {
    const { classes, section, site } = this.props;
    const { data, selectedTab, dialogOpen, dialogData } = this.state;
    const { styles } = section;

    const tabs = data.items && getUniqueValues(data.items.map(item => item.date));

    const items = data.items && data.items.filter(item => item.date === tabs[selectedTab]);

    const colors = getTextColorsFromSection(site, section);

    return (
      <Section site={site} section={section} withPadding withOpenDialog={dialogOpen}>
        <SectionTitle title={section.data.title} style={{ ...colors.title, ...styles.title }} />
        <ScheduleTabs
          tabs={tabs}
          styles={{ ...styles, colors }}
          selectedTab={selectedTab}
          onTabClick={this.onTabClick}
        />
        <div className={classes.mainArea}>
          {items && <ScheduleDay items={items} styles={{ ...styles, colors }} />}
          {Boolean(data.tracks && data.tracks.length) && (
            <ScheduleTracks
              title={data.trackTitle}
              tracks={data.tracks}
              styles={{ ...styles, colors }}
            />
          )}
        </div>
        <ScheduleDialog
          open={dialogOpen}
          data={dialogData}
          styles={styles}
          onRequestClose={this.onRequestDialogClose}
        />
      </Section>
    );
  }
}

const stylesheet = theme => ({
  mainArea: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
});

export default compose(
  injectIntl,
  injectSheet(stylesheet),
)(ScheduleSection);



// WEBPACK FOOTER //
// ./src/site-render/src/ScheduleSection/ScheduleSection.js